import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { Table } from "react-bootstrap";
import { API_URL } from "../../../constants";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    DeleteServiceCaller,
    GetServiceCaller,
    PostServiceCaller,
} from "../../../services/serviceCaller";
import * as Yup from "yup";
import { FaSpinner } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import FuseLoading from "../../../components/FuseLoading";
import DeleteModal from "../../../components/DeletePopUpComponent";



const PMQuestionMaster = () => {


    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("PM Question Master"))
    }, [])
    const initialFormData = {
        Title: "",
        Question: "",
        selectedOption: null,
        Weightage: "",
        Active: 1,
        MinCharacter: "",
        MaxCharacter: "",
        Option1: "",
        Option2: "",
        Option3: "",
        Option4: "",
        Option5: "",
        OptionWeightage1: "",
        OptionWeightage2: "",
        OptionWeightage3: "",
        OptionWeightage4: "",
        OptionWeightage5: "",
        QuestionType_202: null,
    };
    // new area
    const [PRQues, setPRQues] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [questionTypeOptions, setQuestionTypeOptions] = useState([]);
    const [errors, setErrors] = useState({});
    console.log("errors::", errors);

    const [inputDisabled, setInputDisabled] = useState(false);
    const [showSubmitButton, setShowSubmitButton] = useState(true);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(initialFormData);
    console.log("formData::", formData);
    const [prQueID, setPrQueId] = useState("");
    const [apiStatus, setApiStatus] = useState(undefined);
    const [prQueDeleteID, setPrQueDeleteID] = useState("");

    const columns = {
        Title: { text: "Title", align: "start", visible: true },
        Question: { text: "Question", align: "start", visible: true },
        QuestionType: { text: "Type", align: "center", visible: true },
        Weightage: { text: "Weightage", align: "center", visible: true },
        Active: { text: "Active", align: "center", visible: true },
        CreatedByName: { text: "Created By", align: "start", visible: true },
    };


    useEffect(() => {
        fetchPRQues();
        // setApiStatus("");
        setPRQues([])
    }, []);

    useEffect(() => {
        if (prQueID != "") {
            fetchPRQuesID(prQueID);
        }
    }, [prQueID]);

    const fetchPRQues = async () => {
        setApiStatus(undefined)
        try {
            const response = await GetServiceCaller(`${API_URL}pm-question-master`);

            setApiStatus(response?.status)
            if (response?.status === 200) {
                const data = response?.data?.data?.questions;
                const options = response?.data?.data?.questiontype?.map((item) => ({
                    value: item?.value,
                    label: item?.text,
                }));
                setQuestionTypeOptions(options);
                setPRQues(data);
                setPrQueId("");
                //option

            }
        } catch (error) {
            console.error("Error fetching skills:", error);
        }
    };


    const fetchPRQuesID = async (id) => {
        try {
            const response = await GetServiceCaller(`${API_URL}pm-question-master/${id}`);

            if (response.status === 200) {
                const quesData = response?.data?.data;
                const options = response?.data?.questiontype?.map((item) => ({
                    value: item?.value,
                    label: item?.text,
                }));
                setQuestionTypeOptions(options);
                if (quesData) {
                    const {
                        Title,
                        Question,
                        Weightage,
                        MinCharacter,
                        MaxCharacter,
                        Option1,
                        Option2,
                        ID,
                        Option3,
                        Option4,
                        Option5,
                        OptionWeightage1,
                        OptionWeightage2,
                        OptionWeightage3,
                        OptionWeightage4,
                        OptionWeightage5,
                        QuestionType_202,
                        IsInactive,
                    } = quesData;

                    const selectedOption = questionTypeOptions?.find(
                        (option) => option?.value === formData.QuestionType_202
                    );
                    // Update form data with fetched values
                    setFormData({
                        Title: Title || null,
                        Question: Question || null,
                        ID: ID,
                        Weightage: Weightage || "",
                        MinCharacter: MinCharacter || "",
                        MaxCharacter: MaxCharacter || "",
                        Option1: Option1 || "",
                        Option2: Option2 || "",
                        Option3: Option3 || "",
                        Option4: Option4 || "",
                        Option5: Option5 || "",
                        OptionWeightage1: OptionWeightage1 || "",
                        OptionWeightage2: OptionWeightage2 || "",
                        OptionWeightage3: OptionWeightage3 || "",
                        OptionWeightage4: OptionWeightage4 || "",
                        OptionWeightage5: OptionWeightage5 || "",
                        QuestionType_202: QuestionType_202 || null,
                        selectedOption: selectedOption || null,
                         Active: IsInactive === 0 ? 1 : 0,
                    });
                } else {
                    console.error("PM Ques Master not found with ID:", id);
                }
            } else {
                console.error(
                    "Failed to fetch PM Ques Master details. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching PM Ques Master details:", error);
        }
    };


    const handleEdit = async (id) => {
        setShowModal(true);
        setPrQueId(id.ID);
    };

    const handleView = async (id) => {
        setShowModal(true);
        setPrQueId(id.ID);
        setInputDisabled(true);
        setShowSubmitButton(false);
    };


    const resetFormState = () => {
        setFormData({
            Title: null,
            Question: null,
            selectedOption: null,
            Weightage: "",
            Active: 1,
            MinCharacter: "",
            MaxCharacter: "",
            Option1: "",
            Option2: "",
            Option3: "",
            Option4: "",
            Option5: "",
            OptionWeightage1: "",
            OptionWeightage2: "",
            OptionWeightage3: "",
            OptionWeightage4: "",
            OptionWeightage5: "",
            QuestionType_202: null,
        });
        setErrors({});
        setInputDisabled(false);
        setShowSubmitButton(true);
    };

    const handleEditModalClose = () => {
        setShowModal(false);
        setPrQueId("");
        resetFormState();
    };

    const handleAddForm = () => {
        setShowModal(true);
        resetFormState();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            // Validate the entire form data
            await schema.validate(formData, { abortEarly: false });
            setErrors({});

            const url = formData.ID
                ? `${API_URL}pm-question-master/${formData.ID}`
                : `${API_URL}pm-question-master`;
            const method = formData.ID ? "put" : "post";


            const sendData = { ...formData, selectedOption: formData.QuestionType_202 }
            const response = await PostServiceCaller(url, sendData, method);

            if (response.status === 200) {
                toast.success(
                    formData.ID
                        ? "PM Questions updated successfully!"
                        : "PM Questions submitted successfully!"
                );
                // setShowModal(false);
                fetchPRQues();
                setShowModal(false)
                resetFormState();
            } else {
                console.error(`Failed to submit data. Status: ${response.status}`);
                toast.error("An error occurred while submitting the data.");
            }
        } catch (error) {
            console.error("Error during form submission:", error);

            if (error.name === "ValidationError") {
                const formattedErrors = error.inner.reduce((acc, err) => {
                    // Safely handle paths that might be undefined
                    if (err.path) {
                        return { ...acc, [err.path]: err.message };
                    }
                    return acc;
                }, {});
                setErrors(formattedErrors);
                return;
            }

            toast.error(
                formData.ID
                    ? "Failed to update PM Questions"
                    : "PM Questions Not Submitted"
            );
        } finally {
            setLoading(false);
        }

    };
    const schema = Yup.object().shape({
        Title: Yup.string().required("Title is required"),
        Question: Yup.string().required("Question is required"),
        QuestionType_202: Yup.number()
            .typeError("Type is required")
            .required("Type is required")
        ,

        Weightage: Yup.number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .when("QuestionType_202", {
                is: (val) => val === null || val === 1342, // ✅ null OR 1342
                then: (schema) => schema.required("Weightage is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

        Active: Yup.number(),

        // Min & Max characters (only for text type)
        MinCharacter: Yup.number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .when("QuestionType_202", {
                is: 1342,
                then: (schema) => schema.required("Min Character is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

        MaxCharacter: Yup.number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .when("QuestionType_202", {
                is: 1342,
                then: (schema) => schema.required("Max Character is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

        // Option fields (only for MCQ type)
        Option1: Yup.string()
            .when("QuestionType_202", {
                is: 1343,
                then: (schema) => schema.required("Option 1 is required"),
                otherwise: (schema) => schema.notRequired(),
            }),
        Option2: Yup.string()
            .when("QuestionType_202", {
                is: 1343,
                then: (schema) => schema.required("Option 2 is required"),
                otherwise: (schema) => schema.notRequired(),
            }),
        Option3: Yup.string()
            .when("QuestionType_202", {
                is: 1343,
                then: (schema) => schema.required("Option 3 is required"),
                otherwise: (schema) => schema.notRequired(),
            }),
        Option4: Yup.string()
            .when("QuestionType_202", {
                is: 1343,
                then: (schema) => schema.required("Option 4 is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

        OptionWeightage1: Yup.number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .when("QuestionType_202", {
                is: 1343,
                then: (schema) => schema.required("Option 1 weightage is required"),
                otherwise: (schema) => schema.notRequired(),
            }),
        OptionWeightage2: Yup.number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .when("QuestionType_202", {
                is: 1343,
                then: (schema) => schema.required("Option 2 weightage is required"),
                otherwise: (schema) => schema.notRequired(),
            }),
        OptionWeightage3: Yup.number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .when("QuestionType_202", {
                is: 1343,
                then: (schema) => schema.required("Option 3 weightage is required"),
                otherwise: (schema) => schema.notRequired(),
            }),
        OptionWeightage4: Yup.number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .when("QuestionType_202", {
                is: 1343,
                then: (schema) => schema.required("Option 4 weightage is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

        // ... repeat for other options (Option2, Option3, etc.)
    });


    const validateField = async (name, value) => {
        try {
            await schema.validateAt(name, { ...formData, [name]: value });
            setErrors((prev) => ({ ...prev, [name]: "" })); // Clear error for the field
        } catch (err) {
            setErrors((prev) => ({ ...prev, [name]: err.message })); // Set error message
        }
    };

    const handleChange = async (e) => {
        const { name, type, checked, value } = e.target;
        const updatedValue = type === "checkbox" ? (checked ? 1 : 0) : value;

        setFormData((prevData) => {
            const updatedData = { ...prevData, [name]: updatedValue };

            // Validate the field if it exists in the schema
            if (schema.fields[name]) {
                schema.validateAt(name, updatedData)
                    .then(() => setErrors((prev) => ({ ...prev, [name]: "" })))
                    .catch((err) => setErrors((prev) => ({ ...prev, [name]: err.message })));
            }

            return updatedData;
        });
    };
    const handleMCQChange = (name, value) => {
        const updatedValue = value
        setFormData((prevData) => {
            const updatedData = { ...prevData, [name]: updatedValue };

            // Validate the field if it exists in the schema
            if (schema.fields[name]) {
                schema.validateAt(name, updatedData)
                    .then(() => setErrors((prev) => ({ ...prev, [name]: "" })))
                    .catch((err) => setErrors((prev) => ({ ...prev, [name]: err.message })));
            }

            return updatedData;
        });
    };


    const handleSelect = async (selectedOption, name) => {
        setFormData((prevData) => {
            const updatedData = { ...prevData, [name]: selectedOption ? selectedOption.value : null };
            // Trigger validation for the specific field after updating formData
            validateField(name, selectedOption ? selectedOption.value : null);
            return updatedData;
        });
    };
    const handleDeleteOpen = (item) => {
        setShowDeleteModal(true);
        setSelectedDeleteItem(item);
    };



    const handleModalDelete = () => {
        if (selectedDeleteItem) {
            handleDeleteQuestion(selectedDeleteItem.ID);
        }
        setShowDeleteModal(false);
        setSelectedDeleteItem(null);

    }



    const handleDeleteClose = () => {
        setShowDeleteModal(false);
        setSelectedDeleteItem(null);

    };

    const handleDeleteQuestion = async (queMasterID) => {
        // e.preventDefault();
        setLoading(true);
        try {
            const response = await DeleteServiceCaller(
                `${API_URL}question-master/${queMasterID}`,
                {},
                "delete"
            );
            if (response.status === 200) {
                setShowDeleteModal(false);
                setLoading(false);
                fetchPRQues();
            }
        } catch (error) {
            setLoading(false);
            console.error("Error fetching skills:", error);
        }
    };




    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

    return (
        <>
            <div className="container-fluid" id="skill_section">

                <div className="container-fluid" id="skill-table-area">
                    <div className="row mt-2">
                        <Dynamic_PR_table
                            data={PRQues}
                            columns={columns}
                            itemsPerPage={10}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            showIcon1={true}
                            showIcon2={false}
                            isSrNoRequired={true}
                            showIcon3={true}
                            isSorting={false}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            isActionRequired={true}
                            isAddNewBtnRequired={true}
                            handleAddNew={handleAddForm}
                            handleIcon1={handleEdit}
                            handleIcon2={handleDeleteOpen}
                            handleIcon3={handleView}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i className="bi bi-pencil-square icons"></i>,
                                Icon2: <i className="bi bi-trash-fill icons"></i>,
                                Icon2Text: "Delete",
                                Icon2Flag: "CanBeDelete",
                                Icon3: <i className="bi bi-eye-fill icons"></i>,
                                Icon3Text: "View",
                            }}
                        />
                    </div>
                </div>


                {/* Bootstrap Modal */}
                <div>
                    {showModal && (
                        <div
                            className="modal "
                            tabIndex="-1"
                            role="dialog"
                            style={{
                                display: "block",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                            }}
                        >
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header d-flex justify-content-between">
                                        <h3 className="heading skill-heading">
                                            PM Question Master
                                        </h3>
                                        <span className="me-2">
                                            <i
                                                className="bi bi-x-lg"
                                                onClick={handleEditModalClose}
                                            ></i>
                                        </span>
                                    </div>
                                    <div className="modal-body">
                                        <div className="">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="mb-3">
                                                        <label
                                                            htmlFor="exampleInputEmail1"
                                                            className="form-label"
                                                        >
                                                            Title<span className="required">*</span>
                                                        </label>
                                                        <textarea
                                                            className={`form-control ${errors.Title ? "is-invalid" : ""}`}
                                                            id="exampleFormControlTextarea1"
                                                            rows="3"
                                                            name="Title"
                                                            value={formData.Title} // Controlled input
                                                            onChange={handleChange} // Handle input change
                                                            disabled={inputDisabled} // Disable if inputDisabled is true
                                                        ></textarea>
                                                        {errors.Title && (
                                                            <div className="invalid-feedback">
                                                                {errors.Title}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="mb-3">
                                                        <label
                                                            htmlFor="exampleInputEmail1"
                                                            className="form-label"
                                                        >
                                                            Question<span className="required">*</span>
                                                        </label>
                                                        <textarea
                                                            className={`form-control ${errors.Question ? "is-invalid" : ""}`}
                                                            id="exampleFormControlTextarea1"
                                                            rows="3"
                                                            name="Question"
                                                            value={formData.Question} // Controlled input
                                                            onChange={handleChange} // Handle input change
                                                            disabled={inputDisabled} // Disable if inputDisabled is true
                                                        ></textarea>
                                                        {errors.Question && (
                                                            <div className="invalid-feedback">
                                                                {errors.Question}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="type" className="col-form-label">
                                                            <strong>Type</strong>
                                                            <span className="required">*</span>
                                                        </label>
                                                        <Select
                                                            id="type"
                                                            value={questionTypeOptions?.find(option => option.value === formData.QuestionType_202)} // Ensure the value matches the selected option object
                                                            onChange={(selectedOption, action) =>
                                                                handleSelect(selectedOption, action.name)
                                                            }
                                                            name="QuestionType_202"
                                                            isDisabled={inputDisabled}
                                                            options={questionTypeOptions}
                                                            className={`form-control p-0 ${errors.QuestionType_202 ? "is-invalid" : ""}`}
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                }),
                                                            }}
                                                            aria-describedby="type"
                                                        />
                                                        {errors.QuestionType_202 && (
                                                            <div className="invalid-feedback">
                                                                {errors.QuestionType_202}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <label
                                                            htmlFor="Weightage"
                                                            className="col-form-label"
                                                        >
                                                            <strong>Weightage</strong><span className="error">*</span>
                                                        </label>

                                                        <input
                                                            type="number"
                                                            id="Weightage"
                                                            className={`form-control ${errors.Weightage ? "is-invalid" : ""}`}
                                                            name="Weightage"
                                                            value={formData.Weightage || ""} // Ensuring it defaults to an empty string if undefined
                                                            onChange={(e) => handleChange(e)}
                                                            disabled={inputDisabled}
                                                        />
                                                        {errors.Weightage && (
                                                            <div className="invalid-feedback">
                                                                {errors.Weightage}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 mb-2 d-flex">
                                                        <label className="form-label">Active</label>
                                                        <div>
                                                            <input
                                                                className="ms-2 form-check-input"
                                                                type="checkbox"
                                                                name="Active"
                                                                checked={formData.Active === 1} // Ensure that it checks for 1
                                                                onChange={handleChange} // Handle checkbox change
                                                                disabled={inputDisabled}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {/* Descriptive Section  */}
                                                        {formData.QuestionType_202 &&
                                                            formData.QuestionType_202 ===
                                                            1342 && (
                                                                <div className="row">
                                                                    <div className="col-12 col-md-6 mb-3">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-4">
                                                                                <label
                                                                                    htmlFor="MinCharacter"
                                                                                    className="col-form-label"
                                                                                >
                                                                                    <strong>Min Character</strong><span className="required">*</span>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-8">
                                                                                <input
                                                                                    type="number"
                                                                                    id="minCharacter"
                                                                                    name="MinCharacter"
                                                                                    className={`form-control ${errors.MinCharacter ? "is-invalid" : ""}`}
                                                                                    value={formData.MinCharacter || ""}
                                                                                    onChange={(e) =>
                                                                                        handleChange(e)
                                                                                    }
                                                                                    aria-describedby="MinCharacter"
                                                                                    disabled={inputDisabled}
                                                                                />
                                                                                {errors.MinCharacter && (
                                                                                    <div className="invalid-feedback">
                                                                                        {errors.MinCharacter}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 col-md-6 mb-3">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-4">
                                                                                <label
                                                                                    htmlFor="MaxCharacter"
                                                                                    className="col-form-label"
                                                                                >
                                                                                    <strong>Max Character</strong><span className="required">*</span>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-8">
                                                                                <input
                                                                                    type="number"
                                                                                    // id="MaxCharacter"
                                                                                    name="MaxCharacter"
                                                                                    className={`form-control ${errors.MaxCharacter ? "is-invalid" : ""}`}
                                                                                    value={formData.MaxCharacter}
                                                                                    onChange={(e) =>
                                                                                        handleChange(e)
                                                                                    }
                                                                                    aria-describedby="MaxCharacter"
                                                                                    disabled={inputDisabled}
                                                                                />
                                                                                {errors.MaxCharacter && (
                                                                                    <div className="invalid-feedback">
                                                                                        {errors.MaxCharacter}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                    </div>
                                                    {/* MCQs Section and MSQs Section */}
                                                    {formData.QuestionType_202 &&
                                                        (formData.QuestionType_202 === 1343 ||
                                                            formData.QuestionType_202 === 1347) && (
                                                            <div className="mt-4">
                                                                <Table bordered>
                                                                    <thead id="thcolor" className="text-center">
                                                                        <tr>
                                                                            <th className="col-10 text-start">Options<span className="error">*</span></th>
                                                                            <th className="col-2">Weightage<span className="error">*</span></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {/* Option 1 */}
                                                                        <tr>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control ${errors.Option1 ? "is-invalid" : ""}`}
                                                                                            placeholder="Option 1"
                                                                                            value={formData.Option1}
                                                                                            name="Option1"
                                                                                            onChange={(e) => handleMCQChange("Option1", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.Option1 && (
                                                                                            <div className="invalid-feedback">{errors.Option1}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="number"
                                                                                            className={`form-control ${errors.OptionWeightage1 ? "is-invalid" : ""}`}
                                                                                            value={formData.OptionWeightage1}
                                                                                            name="OptionWeightage1"
                                                                                            onChange={(e) => handleMCQChange("OptionWeightage1", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.OptionWeightage1 && (
                                                                                            <div className="invalid-feedback">{errors.OptionWeightage1}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>

                                                                        {/* Option 2 */}
                                                                        <tr>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control ${errors.Option2 ? "is-invalid" : ""}`}
                                                                                            placeholder="Option 2"
                                                                                            value={formData.Option2}
                                                                                            name="Option2"
                                                                                            onChange={(e) => handleMCQChange("Option2", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.Option2 && (
                                                                                            <div className="invalid-feedback">{errors.Option2}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="number"
                                                                                            className={`form-control ${errors.OptionWeightage2 ? "is-invalid" : ""}`}
                                                                                            value={formData.OptionWeightage2}
                                                                                            name="OptionWeightage2"
                                                                                            onChange={(e) => handleMCQChange("OptionWeightage2", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.OptionWeightage2 && (
                                                                                            <div className="invalid-feedback">{errors.OptionWeightage2}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>

                                                                        {/* Option 3 */}
                                                                        <tr>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control ${errors.Option3 ? "is-invalid" : ""}`}
                                                                                            placeholder="Option 3"
                                                                                            value={formData.Option3}
                                                                                            name="Option3"
                                                                                            onChange={(e) => handleMCQChange("Option3", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.Option3 && (
                                                                                            <div className="invalid-feedback">{errors.Option3}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="number"
                                                                                            className={`form-control ${errors.OptionWeightage3 ? "is-invalid" : ""}`}
                                                                                            value={formData.OptionWeightage3}
                                                                                            name="OptionWeightage3"
                                                                                            onChange={(e) => handleMCQChange("OptionWeightage3", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.OptionWeightage3 && (
                                                                                            <div className="invalid-feedback">{errors.OptionWeightage3}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>

                                                                        {/* Option 4 */}
                                                                        <tr>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control ${errors.Option4 ? "is-invalid" : ""}`}
                                                                                            placeholder="Option 4"
                                                                                            value={formData.Option4}
                                                                                            name="Option4"
                                                                                            onChange={(e) => handleMCQChange("Option4", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.Option4 && (
                                                                                            <div className="invalid-feedback">{errors.Option4}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="number"
                                                                                            className={`form-control ${errors.OptionWeightage4 ? "is-invalid" : ""}`}
                                                                                            value={formData.OptionWeightage4}
                                                                                            name="OptionWeightage4"
                                                                                            onChange={(e) => handleMCQChange("OptionWeightage4", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.OptionWeightage4 && (
                                                                                            <div className="invalid-feedback">{errors.OptionWeightage4}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>

                                                                        {/* Option 5 */}
                                                                        <tr>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control ${errors.Option5 ? "is-invalid" : ""}`}
                                                                                            placeholder="Option 5"
                                                                                            value={formData.Option5}
                                                                                            name="Option5"
                                                                                            onChange={(e) => handleMCQChange("Option5", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.Option5 && (
                                                                                            <div className="invalid-feedback">{errors.Option5}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            type="number"
                                                                                            className={`form-control ${errors.OptionWeightage5 ? "is-invalid" : ""}`}
                                                                                            value={formData.OptionWeightage5}
                                                                                            name="OptionWeightage5"
                                                                                            onChange={(e) => handleMCQChange("OptionWeightage5", e.target.value)}
                                                                                            disabled={inputDisabled}
                                                                                        />
                                                                                        {errors.OptionWeightage5 && (
                                                                                            <div className="invalid-feedback">{errors.OptionWeightage5}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        )}
                                                </div>
                                                <div className="text-end">
                                                    <button
                                                        className="cancel-btn me-2"
                                                        onClick={handleEditModalClose}
                                                    >
                                                        Cancel
                                                    </button>
                                                    {showSubmitButton && (
                                                        <button
                                                            type="button"
                                                            disabled={loading ? true : false}
                                                            className="custom-btn me-2"
                                                            onClick={handleSubmit}
                                                        >
                                                            {loading ? (
                                                                <FaSpinner class="sm-spinner" />
                                                            ) : (
                                                                "Submit"
                                                            )}
                                                        </button>
                                                    )}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <DeleteModal
                    show={showDeleteModal}
                    onClose={handleDeleteClose}
                    onConfirm={handleModalDelete}
                    message="Are you sure you want to delete this item?"
                />
            </div>
        </>
    );
};

export default PMQuestionMaster;
